export * from './email.validator';
export * from './equalPasswords.validator';


// WEBPACK FOOTER //
// ./src/app/theme/validators/index.ts